;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"prex-frontend-nextjs@release-web-2.40.112"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;import * as Sentry from '@sentry/nextjs';

import { SentryConfig } from '@web/utils/sentry-config';

Sentry.init({
  ...SentryConfig,
  // Replay may only be enabled for the client-side
  integrations: [Sentry.browserTracingIntegration()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1,
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1.0,
  beforeSend(event, hint) {
    const error = hint.originalException as Error | undefined;

    if (error?.stack && !/_next|node_modules/gm.test(error.stack)) {
      return null;
    }
    if (error?.message) {
      if (
        [
          'Request timed out',
          'timeout of 10000ms exceeded',
          'Invalid regular expression: /\\p{P}|\\p{S}/: Invalid escape',
        ].find((message) => error.message.match(message))
      ) {
        return null;
      }
    }
    return event;
  },
  denyUrls: ['https://in.ap1.segmentapis.com', 'https://browser-intake-datadoghq.com'],
});
